// External Dependencies:
import React from 'react'
import { Link } from 'react-router-dom'

class HomeImageLinks extends React.Component {
	render() {
		return (
			<div className="image-links">
				<div className="image-link-wrap">
					<Link to="/programs" className="image-link -a">
						<div className="-inner">
							<div className="-title">
								<h3>Programs &amp; Podcasts</h3>
							</div>

							<div className="-image">
								<img src={ `${siteData.images_url}cards/in_studio_1_small.jpg` } alt="" />
							</div>
						</div>
					</Link>
				</div>

				<div className="image-link-wrap">
					<Link to="/offers" className="image-link -b">
						<div className="-inner">
							<div className="-title">
								<h3>Offers</h3>
							</div>

							<div className="-image">
								<img src={ `${siteData.images_url}cards/listening_in_grass_small.jpg` } alt="" />
							</div>
						</div>
					</Link>
				</div>

				<div className="image-link-wrap">
					<Link to="/contact" className="image-link -c">
						<div className="-inner">
							<div className="-title">
								<h3>Contact Us</h3>
							</div>

							<div className="-image">
								<img src={ `${siteData.images_url}cards/smiling-girl.jpg` } alt="" />
							</div>
						</div>
					</Link>
				</div>

				<div className="image-link-wrap">
					<Link to="/get-involved" className="image-link -d">
						<div className="-inner">
							<div className="-title">
								<h3>Get Involved</h3>
							</div>

							<div className="-image">
								<img src={ `${siteData.images_url}cards/happy-boy.jpg` } alt="" />
							</div>
						</div>
					</Link>
				</div>
			</div>
		)
	}
}

export default HomeImageLinks
